import { z } from 'zod';

export const zodInvoiceCommentPayloadSchema = z.object({
  comment: z.string().trim().min(1),
});
